import { render, staticRenderFns } from "./BoardAnnoucementWidget.vue?vue&type=template&id=35748a0c&scoped=true"
import script from "./BoardAnnoucementWidget.vue?vue&type=script&lang=js"
export * from "./BoardAnnoucementWidget.vue?vue&type=script&lang=js"
import style0 from "./BoardAnnoucementWidget.vue?vue&type=style&index=0&id=35748a0c&prod&lang=scss"
import style1 from "./BoardAnnoucementWidget.vue?vue&type=style&index=1&id=35748a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35748a0c",
  null
  
)

export default component.exports